module.exports = __webpack_public_path__ + "static/media/eod.578b5042.png";